<template>
  <div>
    <!-- 顶部统计卡片 -->
    <Row :gutter="24" style="margin-top: 20px">
      <Col span="8">
        <Card dis-hover class="stat-card stat-blue" @click.native="scrollToFleetList">
          <div class="stat-content">
            <div class="stat-value">{{ info.company_num || 0 }}</div>
            <div class="stat-label">名下车队</div>
            <div class="stat-icon">
              <Icon type="ios-people" />
            </div>
          </div>
        </Card>
      </Col>

      <Col span="8">
        <Card dis-hover class="stat-card stat-cyan">
          <div class="stat-content">
            <div class="stat-value">{{ info.station_num || 0 }}</div>
            <div class="stat-label">可用站点</div>
            <div class="stat-icon">
              <Icon type="ios-locate" />
            </div>
          </div>
        </Card>
      </Col>



      <Col span="8">
        <Card dis-hover class="stat-card stat-red">
          <div class="stat-content">
            <div class="stat-double">
              <div class="stat-double-item stat-refund-wait" @click="goToOrderList('', '1')">
                <div class="stat-value">{{ info.wait_refund_order_num || 0 }}</div>
                <div class="stat-label">
                  <Icon type="ios-timer" />
                  <span>待退款</span>
                </div>
              </div>
              <div class="stat-divider"></div>
              <div class="stat-double-item stat-refund-done" @click="goToOrderList('', '5')">
                <div class="stat-value">{{ info.refunded_order_num || 0 }}</div>
                <div class="stat-label">
                  <Icon type="ios-checkmark-circle" />
                  <span>已退款</span>
                </div>
              </div>
            </div>
            <div class="stat-icon">
              <Icon type="ios-close-circle" />
            </div>
          </div>
        </Card>
      </Col>
    </Row>
    <Row :gutter="24" style="margin-top: 16px">
      <Col span="8">
        <Card dis-hover class="stat-card stat-green" @click.native="goToOrderList('today')">
          <div class="stat-content">
            <div class="stat-value">{{ info.today_order_num || 0 }}</div>
            <div class="stat-label">今日订单</div>
            <div class="stat-sub">
              <span>{{ formatLitre(info.today_litre_num) }} L</span>
              <span class="split">|</span>
              <span>¥ {{ formatMoney(info.today_amount) }}</span>
            </div>
            <div class="stat-icon">
              <Icon type="ios-calendar" />
            </div>
          </div>
        </Card>
      </Col>

      <Col span="8">
        <Card dis-hover class="stat-card stat-orange" @click.native="goToOrderList('month')">
          <div class="stat-content">
            <div class="stat-value">{{ info.month_order_num || 0 }}</div>
            <div class="stat-label">本月订单</div>
            <div class="stat-sub">
              <span>{{ formatLitre(info.month_litre_num) }} L</span>
              <span class="split">|</span>
              <span>¥ {{ formatMoney(info.month_amount) }}</span>
            </div>
            <div class="stat-icon">
              <Icon type="ios-albums" />
            </div>
          </div>
        </Card>
      </Col>

      <Col span="8">
        <Card dis-hover class="stat-card stat-purple" @click.native="goToOrderList('')">
          <div class="stat-content">
            <div class="stat-value">{{ info.total_order_num || 0 }}</div>
            <div class="stat-label">累计订单</div>
            <div class="stat-sub">
              <span>{{ formatLitre(info.total_litre_num) }} L</span>
              <span class="split">|</span>
              <span>¥ {{ formatMoney(info.total_amount) }}</span>
            </div>
            <div class="stat-icon">
              <Icon type="ios-stats" />
            </div>
          </div>
        </Card>
      </Col>
    </Row>

    <!-- 订单趋势 -->
    <Row :gutter="16" style="margin-top: 16px">
      <Col span="24">
        <Card dis-hover class="chart-card">
          <div slot="title" class="card-title-with-badge">
            <span class="title-text">名下订单趋势</span>
            <div class="trend-filters">
              <Select
                v-model="trendCompanyId"
                filterable
                clearable
                placeholder="全部车队"
                style="width: 220px"
                @on-change="getTrend"
              >
                <Option v-for="item in companyOptions" :key="item.company_id" :value="item.company_id" :label="item.company_name">{{ item.company_name }}</Option>
              </Select>
              <Select v-model="trendDays" style="width: 120px" @on-change="getTrend">
                <Option :value="7" label="近7天" />
                <Option :value="14" label="近14天" />
                <Option :value="30" label="近30天" />
                <Option :value="90" label="近90天" />
              </Select>
            </div>
          </div>

          <!-- 汇总统计 -->
          <div v-if="trendSummary" class="trend-summary">
            <div class="trend-summary-item">
              <div class="ts-label">总订单数</div>
              <div class="ts-value ts-blue">{{ trendSummary.order_num || 0 }}</div>
            </div>
            <div class="trend-summary-item">
              <div class="ts-label">总加注量(L)</div>
              <div class="ts-value ts-green">{{ formatLitre(trendSummary.litre_num) }}</div>
            </div>
            <div class="trend-summary-item">
              <div class="ts-label">总金额(元)</div>
              <div class="ts-value ts-orange">¥ {{ formatMoney(trendSummary.total_price) }}</div>
            </div>
            <div class="trend-summary-item">
              <div class="ts-label">日均订单 / 加注(L)</div>
              <div class="ts-value ts-purple">
                <span>{{ avgDailyOrder }}</span>
                <span class="ts-split">/</span>
                <span>{{ avgDailyLitre }}</span>
              </div>
            </div>
          </div>

          <div v-show="trendLoading" style="text-align: center; padding: 80px 0;">
            <Spin size="large"></Spin>
          </div>
          <div v-show="!trendLoading" ref="trendChart" style="width: 100%; height: 350px;"></div>
        </Card>
      </Col>
    </Row>

    <!-- 车队加注排名 -->
    <Row :gutter="16" style="margin-top: 16px">
      <Col span="24">
        <Card dis-hover class="chart-card">
          <div slot="title" class="card-title-with-badge">
            <div class="rank-title">
              <span class="title-text">车队加注排名 <span class="rank-tip">只展示有数据的车队</span></span>
            </div>
            <div class="trend-filters">
<!--              <span class="rank-sub">加注量 TOP10</span>-->
              <DatePicker
                v-model="rankDate"
                type="daterange"
                placeholder="选择时间范围"
                style="width: 220px"
                @on-change="rankDateChange"
              ></DatePicker>
            </div>
          </div>
          <div v-show="rankLoading" style="text-align: center; padding: 80px 0;">
            <Spin size="large"></Spin>
          </div>
          <div v-show="!rankLoading" ref="rankChart" style="width: 100%; height: 400px;"></div>
        </Card>
      </Col>
    </Row>

    <!-- 加油站排行 & 车队加油排行 -->
    <Row :gutter="16" style="margin-top: 16px">
      <Col span="12">
        <Card dis-hover class="ranking-list-card">
          <div slot="title" class="card-title-with-badge">
            <span class="title-text">加油站排行</span>
            <Badge :count="5" type="warning" />
          </div>
          <div v-if="oilRangeSummary.total_litre !== undefined || oilRangeSummary.total_profit !== undefined" class="table-summary-bar">
            <span>升数合计：{{ formatLitre(oilRangeSummary.total_litre) }} L</span>
            <span>利润合计：¥{{ formatMoney(oilRangeSummary.total_profit) }}</span>
          </div>
          <pageTable ref="oilRangeTable"
                     :showPage="false"
                     :searchData="oilRangeForm"
                     :tableTitle="oilRangeColumn"
                     tableApi="admin/agent_data/oilRange"
                     :onSortChange="oilRangeSortChange"
                     :doneFunction="handleOilRangeDone"
                     height="400"
          >
            <template v-slot:searchFormItem>
              <FormItem prop="dateRange">
                <DatePicker
                  v-model="oilRangeForm.dateRange"
                  type="daterange"
                  split-panels
                  placement="bottom-start"
                  placeholder="选择时间范围"
                  style="width: 240px"
                  @on-change="(value) => handleRangeDateChange('oilRangeForm', value)"
                ></DatePicker>
              </FormItem>
              <FormItem prop="start_time" v-show="false"></FormItem>
              <FormItem prop="end_time" v-show="false"></FormItem>
            </template>
          </pageTable>
        </Card>
      </Col>

      <Col span="12">
        <Card dis-hover class="ranking-list-card">
          <div slot="title" class="card-title-with-badge">
            <span class="title-text">车队加油排行</span>
            <Badge :count="10" type="info" />
          </div>
          <div v-if="companyOilRangeSummary.total_litre !== undefined || companyOilRangeSummary.total_profit !== undefined" class="table-summary-bar">
            <span>升数合计：{{ formatLitre(companyOilRangeSummary.total_litre) }} L</span>
            <span>利润合计：¥{{ formatMoney(companyOilRangeSummary.total_profit) }}</span>
          </div>
          <pageTable ref="companyOilRangeTable"
                     :showPage="false"
                     :searchData="companyOilRangeForm"
                     :tableTitle="companyOilRangeColumn"
                     tableApi="admin/agent_data/companyOilRange"
                     :onSortChange="companyOilRangeSortChange"
                     :doneFunction="handleCompanyOilRangeDone"
                     height="400"
          >
            <template v-slot:searchFormItem>
              <FormItem prop="dateRange">
                <DatePicker
                  v-model="companyOilRangeForm.dateRange"
                  type="daterange"
                  split-panels
                  placement="bottom-start"
                  placeholder="选择时间范围"
                  style="width: 240px"
                  @on-change="(value) => handleRangeDateChange('companyOilRangeForm', value)"
                ></DatePicker>
              </FormItem>
              <FormItem prop="start_time" v-show="false"></FormItem>
              <FormItem prop="end_time" v-show="false"></FormItem>
            </template>
          </pageTable>
        </Card>
      </Col>
    </Row>

    <!-- 名下车队列表 -->
    <Row :gutter="16" style="margin-top: 16px">
      <Col span="24">
        <Card dis-hover class="ranking-list-card" id="fleetListSection">
          <div slot="title" class="card-title-with-badge">
            <span class="title-text">名下车队</span>
            <Badge :count="info.company_num || 0" type="info" />
          </div>
          <pageTable
            ref="fleetTable"
            :showPage="true"
            :showSearchForm="true"
            :defaultPageSize="10"
            :searchData="fleetSearchData"
            :tableTitle="fleetColumn"
            tableApi="admin/agent_data/getCompanyList"
            @on-row-change="openCompanyDetail"
          >
            <FormItem slot="searchFormItem" >
              <Input
                v-model="fleetSearchData.company_name"
                placeholder="请输入车队名称"
                style="width: 200px"
                clearable
                @on-enter="searchFleet"
              />
            </FormItem>
          </pageTable>
        </Card>
      </Col>
    </Row>

    <!-- 车队详情抽屉 -->
    <Drawer
      v-model="detailVisible"
      :title="detailInfo.company_name || '车队详情'"
      width="780"
      :mask-closable="true"
    >
      <div class="detail-info">
        <Row :gutter="16">
          <Col span="12" class="detail-info-item">
            <span class="label">负责人：</span>
            <span class="value">{{ detailInfo.manager_name || '-' }}</span>
          </Col>
          <Col span="12" class="detail-info-item">
            <span class="label">联系电话：</span>
            <span class="value">{{ detailInfo.manager_mobile || '-' }}</span>
          </Col>
          <Col span="12" class="detail-info-item">
            <span class="label">业务员：</span>
            <span class="value">{{ detailInfo.salesman || '-' }}</span>
          </Col>
          <Col span="12" class="detail-info-item">
            <span class="label">创建时间：</span>
            <span class="value">{{ detailInfo.create_time || '-' }}</span>
          </Col>
          <Col span="12" class="detail-info-item">
            <span class="label">车队余额：</span>
            <span class="value">¥ {{ formatMoney(detailInfo.balance) }}</span>
          </Col>
          <Col span="12" class="detail-info-item">
            <span class="label">车队单价：</span>
            <span class="value">{{ detailInfo.unit_price || 0 }}（{{ detailInfo.pay_type_name || '-' }}）</span>
          </Col>
<!--          <Col span="12" class="detail-info-item">-->
<!--            <span class="label">带票类型：</span>-->
<!--            <span class="value">{{ detailInfo.bill_type_name || '-' }}</span>-->
<!--          </Col>-->
<!--          <Col span="12" class="detail-info-item">-->
<!--            <span class="label">票点金额：</span>-->
<!--            <span class="value">{{ detailInfo.bill_amount || 0 }}</span>-->
<!--          </Col>-->
          <Col span="12" class="detail-info-item">
            <span class="label">待退款订单：</span>
            <span class="value">{{ detailInfo.wait_refund_order_num || 0 }}</span>
          </Col>
          <Col span="12" class="detail-info-item">
            <span class="label">待结算金额：</span>
            <span class="value">¥ {{ formatMoney(detailInfo.wait_settle_amount) }}</span>
          </Col>
          <Col span="12" class="detail-info-item">
            <span class="label">司机卡余额总额：</span>
            <span class="value" style="color: #ed4014;">¥ {{ formatMoney(driverBalanceTotal) }}</span>
          </Col>
          <Col span="12" class="detail-info-item">
            <span class="label">余额总额：</span>
            <span class="value" style="color: #ed4014;">¥ {{ formatMoney(Number(driverBalanceTotal) + Number(detailInfo.balance)) }}</span>
          </Col>
        </Row>
      </div>

      <!-- 订单统计 -->
      <div class="detail-stats">
        <div class="detail-stat-card">
          <div class="ds-title">今日</div>
          <div class="ds-row"><span class="ds-label">订单数</span><span class="ds-value">{{ detailInfo.today_order_num || 0 }}</span></div>
          <div class="ds-row"><span class="ds-label">加注量(L)</span><span class="ds-value">{{ formatLitre(detailInfo.today_litre_num) }}</span></div>
          <div class="ds-row"><span class="ds-label">金额(元)</span><span class="ds-value">¥ {{ formatMoney(detailInfo.today_amount) }}</span></div>
        </div>
        <div class="detail-stat-card">
          <div class="ds-title">本月</div>
          <div class="ds-row"><span class="ds-label">订单数</span><span class="ds-value">{{ detailInfo.month_order_num || 0 }}</span></div>
          <div class="ds-row"><span class="ds-label">加注量(L)</span><span class="ds-value">{{ formatLitre(detailInfo.month_litre_num) }}</span></div>
          <div class="ds-row"><span class="ds-label">金额(元)</span><span class="ds-value">¥ {{ formatMoney(detailInfo.month_amount) }}</span></div>
        </div>
        <div class="detail-stat-card">
          <div class="ds-title">累计</div>
          <div class="ds-row"><span class="ds-label">订单数</span><span class="ds-value">{{ detailInfo.total_order_num || 0 }}</span></div>
          <div class="ds-row"><span class="ds-label">加注量(L)</span><span class="ds-value">{{ formatLitre(detailInfo.total_litre_num) }}</span></div>
          <div class="ds-row"><span class="ds-label">金额(元)</span><span class="ds-value">¥ {{ formatMoney(detailInfo.total_amount) }}</span></div>
        </div>
      </div>

      <Divider style="margin: 16px 0 12px;">可用站点（{{ stationTotal }}）</Divider>

      <div class="station-search">
<!--        <Input v-model="stationSearch.station_id" placeholder="站点ID" style="width: 140px" clearable @on-enter="searchStation"></Input>-->
        <Input v-model="stationSearch.gas_name" placeholder="站点名称" style="width: 180px" clearable @on-enter="searchStation"></Input>
        <Button type="primary" icon="ios-search" @click="searchStation">搜索</Button>
        <Button @click="resetStationSearch">重置</Button>
      </div>

      <Table
        border
        size="small"
        :columns="stationColumns"
        :data="stationList"
        :loading="stationLoading"
        :height="320"
      ></Table>
      <div class="station-page">
        <Page
          v-if="stationTotal > stationPageSize"
          show-total
          :total="stationTotal"
          :current="stationPage"
          :page-size="stationPageSize"
          @on-change="loadStationPage"
        />
      </div>

      <Divider style="margin: 16px 0 12px;">车队司机（{{ driverTotal }}）</Divider>

      <div class="station-search">
        <Input v-model="driverSearch.mobile" placeholder="手机号" style="width: 150px" clearable @on-enter="searchDriver"></Input>
        <Input v-model="driverSearch.car_number" placeholder="车牌号" style="width: 150px" clearable @on-enter="searchDriver"></Input>
        <Button type="primary" icon="ios-search" @click="searchDriver">搜索</Button>
        <Button @click="resetDriverSearch">重置</Button>
        <span class="driver-balance-total">
          <Icon type="ios-wallet" />
          司机卡余额总额：<b>¥ {{ formatMoney(driverBalanceTotal) }}</b>
        </span>
      </div>

      <Table
        border
        size="small"
        :columns="driverColumns"
        :data="driverList"
        :loading="driverLoading"
        :height="320"
      ></Table>
      <div class="station-page">
        <Page
          v-if="driverTotal > driverPageSize"
          show-total
          :total="driverTotal"
          :current="driverPage"
          :page-size="driverPageSize"
          @on-change="loadDriverPage"
        />
      </div>
    </Drawer>

    <!-- 车队加油列表弹窗 -->
    <Modal
      v-model="showCompanyModal"
      title="车队加油列表"
      :width="modalWidth"
      :footer-hide="true"
      :mask-closable="true"
    >
      <div v-if="selectedStation" style="margin-bottom: 16px; padding: 12px; background: #f8f8f9; border-radius: 4px; border-left: 3px solid #2d8cf0;">
        <strong>站点名称：</strong>{{ selectedStation.station_name }} <strong>价格：</strong>{{ selectedStation.price ? parseFloat(selectedStation.price).toFixed(2) + ' 元/L' : '暂无数据' }}
        <strong style="margin-left: 30px;">利润总和：</strong><span :style="{ fontWeight: 'bold', fontSize: '16px', color: companyProfitTotal >= 0 ? '#19be6b' : '#ed4014' }">¥{{ companyProfitTotal.toFixed(2) }}</span>
      </div>
      <Table
        :columns="companyListColumn"
        :data="companyListData"
        :loading="companyListLoading"
        :maxHeight="tableMaxHeight"
        border
        stripe
      ></Table>
    </Modal>

    <!-- 站点加油列表弹窗 -->
    <Modal
      v-model="showStationModal"
      title="站点加油列表"
      :width="modalWidth"
      :footer-hide="true"
      :mask-closable="true"
    >
      <div v-if="selectedCompany" style="margin-bottom: 16px; padding: 12px; background: #f8f8f9; border-radius: 4px; border-left: 3px solid #2d8cf0;">
        <strong>车队名称：</strong>{{ selectedCompany.company_name }}
        <strong style="margin-left: 30px;">利润总和：</strong><span :style="{ fontWeight: 'bold', fontSize: '16px', color: stationProfitTotal >= 0 ? '#19be6b' : '#ed4014' }">¥{{ stationProfitTotal.toFixed(2) }}</span>
      </div>
      <Table
        :columns="stationListColumn"
        :data="stationListData"
        :loading="stationListLoading"
        :maxHeight="tableMaxHeight"
        border
        stripe
      ></Table>
    </Modal>

  </div>
</template>

<script>
  import pageTable from "@/components/table/pageTable";
  import * as echarts from 'echarts';

  export default {
    name: "agent-dashboard",
    components: { pageTable },
    data() {
      return {
        info: {},                    // 数据总览
        fleetSearchData: { company_name: '' },
        fleetColumn: [],
        // 加油站排行 & 车队加油排行
        oilRangeForm: { searchDay: '', start_time: '', end_time: '', dateRange: [], sortKey: '', sortType: '' },
        companyOilRangeForm: { searchDay: '', start_time: '', end_time: '', dateRange: [], sortKey: '', sortType: '' },
        oilRangeSummary: {},
        companyOilRangeSummary: {},
        dateOptions: {
          type: 'daterange',
        },
        // 明细弹窗
        modalWidth: '70%', // 弹窗宽度，自适应屏幕的70%
        tableMaxHeight: 500, // 弹窗内表格最大高度(px)，自适应屏幕高度
        showCompanyModal: false,
        selectedStation: null,
        companyListData: [],
        companyListLoading: false,
        showStationModal: false,
        selectedCompany: null,
        stationListData: [],
        stationListLoading: false,
        oilRangeColumn: [
          {title: '排名', key: 'rank', width: 100, align: "center", render: (h, params) => {
            const rank = params.index + 1;
            let color = '#808695';
            let bgColor = '#f8f8f9';
            let icon = '';
            
            if (rank === 1) {
              color = '#fff';
              bgColor = '#ff9900';
              icon = '🥇';
            } else if (rank === 2) {
              color = '#fff';
              bgColor = '#a0a0a0';
              icon = '🥈';
            } else if (rank === 3) {
              color = '#fff';
              bgColor = '#cd7f32';
              icon = '🥉';
            }
            
            return h('div', {
              style: {
                display: 'inline-flex',
                alignItems: 'center',
                justifyContent: 'center',
                width: '60px',
                height: '28px',
                borderRadius: '14px',
                backgroundColor: bgColor,
                color: color,
                fontWeight: 'bold',
                fontSize: '13px',
                boxShadow: rank <= 3 ? '0 2px 4px rgba(0,0,0,0.1)' : 'none'
              }
            }, rank <= 3 ? `${icon} ${rank}` : rank);
          }},
          {title: '油站名称', key: 'station_name', align: "left", minWidth: 150, render: (h, params) => {
            return h('div', {
              style: {
                display: 'flex',
                alignItems: 'center',
                fontWeight: params.index < 3 ? '600' : 'normal',
                color: params.index < 3 ? '#2d8cf0' : 'inherit',
                cursor: 'pointer'
              },
              on: {
                click: () => {
                  this.showStationCompanyList(params.row)
                }
              }
            }, [
              params.index < 3 ? h('Icon', {
                props: { type: 'ios-star', size: 14 },
                style: { color: '#ff9900', marginRight: '4px' }
              }) : null,
              h('span', params.row.station_name)
            ]);
          }},
          {title: '加油数量(L)', key: 'litre_num', align: "center", width: 180, sortable: 'custom', render: (h, params) => {
            // 计算最大值用于进度条
            const dataList = this.$refs.oilRangeTable ? this.$refs.oilRangeTable.dataLists : [];
            const maxLitre = dataList.length > 0 ? Math.max(...dataList.map(item => item.litre_num)) : 1;
            const percentage = Math.min((params.row.litre_num / maxLitre * 100), 100).toFixed(1);
            
            return h('div', {
              style: {
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                gap: '6px'
              }
            }, [
              h('span', {
                style: {
                  fontWeight: 'bold',
                  color: '#19be6b',
                  fontSize: '15px'
                }
              }, params.row.litre_num.toLocaleString() + ' L'),
              h('Progress', {
                props: {
                  percent: parseFloat(percentage),
                  strokeColor: params.index === 0 ? '#ff9900' : params.index === 1 ? '#2d8cf0' : '#19be6b',
                  strokeWidth: 8,
                  hideInfo: true
                },
                style: { width: '100%' }
              })
            ]);
          }},
        ],
        companyOilRangeColumn:[
          {title: '排名', key: 'rank', width: 100, align: "center", render: (h, params) => {
            const rank = params.index + 1;
            let color = '#808695';
            let bgColor = '#f8f8f9';
            let icon = '';
            
            if (rank === 1) {
              color = '#fff';
              bgColor = '#ff9900';
              icon = '🥇';
            } else if (rank === 2) {
              color = '#fff';
              bgColor = '#a0a0a0';
              icon = '🥈';
            } else if (rank === 3) {
              color = '#fff';
              bgColor = '#cd7f32';
              icon = '🥉';
            }
            
            return h('div', {
              style: {
                display: 'inline-flex',
                alignItems: 'center',
                justifyContent: 'center',
                width: '50px',
                height: '28px',
                borderRadius: '14px',
                backgroundColor: bgColor,
                color: color,
                fontWeight: 'bold',
                fontSize: '13px',
                boxShadow: rank <= 3 ? '0 2px 4px rgba(0,0,0,0.1)' : 'none'
              }
            }, rank <= 3 ? `${icon} ${rank}` : rank);
          }},
          {title: '车队名称', key: 'company_name', align: "left", minWidth: 150, render: (h, params) => {
            return h('div', {
              style: {
                display: 'flex',
                alignItems: 'center',
                fontWeight: params.index < 3 ? '600' : 'normal',
                color: params.index < 3 ? '#2d8cf0' : 'inherit',
                cursor: 'pointer'
              },
              on: {
                click: () => {
                  this.showCompanyStationList(params.row)
                }
              }
            }, [
              params.index < 3 ? h('Icon', {
                props: { type: 'ios-trophy', size: 14 },
                style: { color: '#2d8cf0', marginRight: '4px' }
              }) : null,
              h('span', params.row.company_name)
            ]);
          }},
          {title: '加油数量(L)', key: 'litre_num', align: "center", width: 180, sortable: 'custom', render: (h, params) => {
            // 计算最大值用于进度条
            const dataList = this.$refs.companyOilRangeTable ? this.$refs.companyOilRangeTable.dataLists : [];
            const maxLitre = dataList.length > 0 ? Math.max(...dataList.map(item => item.litre_num)) : 1;
            const percentage = Math.min((params.row.litre_num / maxLitre * 100), 100).toFixed(1);
            
            return h('div', {
              style: {
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                gap: '6px'
              }
            }, [
              h('span', {
                style: {
                  fontWeight: 'bold',
                  color: '#2d8cf0',
                  fontSize: '15px'
                }
              }, params.row.litre_num.toLocaleString() + ' L'),
              h('Progress', {
                props: {
                  percent: parseFloat(percentage),
                  strokeColor: params.index === 0 ? '#ff9900' : params.index === 1 ? '#2d8cf0' : '#19be6b',
                  strokeWidth: 8,
                  hideInfo: true
                },
                style: { width: '100%' }
              })
            ]);
          }},
        ],
        companyListColumn: [
          {title: '排名', key: 'rank', width: 90, align: "center", render: (h, params) => {
            const rank = params.index + 1;
            let color = '#808695';
            let bgColor = '#f8f8f9';
            let icon = '';
            
            if (rank === 1) {
              color = '#fff';
              bgColor = '#ff9900';
              icon = '🥇';
            } else if (rank === 2) {
              color = '#fff';
              bgColor = '#a0a0a0';
              icon = '🥈';
            } else if (rank === 3) {
              color = '#fff';
              bgColor = '#cd7f32';
              icon = '🥉';
            }
            
            return h('div', {
              style: {
                display: 'inline-flex',
                alignItems: 'center',
                justifyContent: 'center',
                width: '50px',
                height: '28px',
                borderRadius: '14px',
                backgroundColor: bgColor,
                color: color,
                fontWeight: 'bold',
                fontSize: '13px',
                boxShadow: rank <= 3 ? '0 2px 4px rgba(0,0,0,0.1)' : 'none'
              }
            }, rank <= 3 ? `${icon} ${rank}` : rank);
          }},
          {title: '车队名称', key: 'company_name', align: "left", minWidth: 180, render: (h, params) => {
            return h('div', {
              style: {
                display: 'flex',
                alignItems: 'center',
                fontWeight: params.index < 3 ? '600' : 'normal',
                color: params.index < 3 ? '#2d8cf0' : 'inherit'
              }
            }, [
              params.index < 3 ? h('Icon', {
                props: { type: 'ios-trophy', size: 14 },
                style: { color: '#2d8cf0', marginRight: '4px' }
              }) : null,
              h('span', params.row.company_name)
            ]);
          }},
          {title: '订单数', key: 'order_count', align: "center", width: 120},
          {title: '加油量(L)', key: 'total_litre', align: "center", width: 150, render: (h, params) => {
            return h('span', {
              style: {
                fontWeight: 'bold',
                color: '#19be6b',
                fontSize: '15px'
              }
            }, parseFloat(params.row.total_litre).toLocaleString() + ' L');
          }},
          {title: '总金额(元)', key: 'total_amount', align: "center", width: 150, render: (h, params) => {
            return h('span', {
              style: {
                fontWeight: 'bold',
                color: '#ff9900'
              }
            }, '¥' + parseFloat(params.row.total_amount).toLocaleString());
          }},
          {title: '单价(元/L)', key: 'price', align: "center", width: 120, render: (h, params) => {
            return h('span', {
              style: {
                fontWeight: 'bold',
                color: '#2d8cf0'
              }
            }, params.row.price.toFixed(2));
          }},
          {title: '价格差(元/L)', key: 'price_diff', align: "center", width: 120, render: (h, params) => {
            const stationPrice = parseFloat(this.selectedStation && this.selectedStation.price);
            const companyPrice = parseFloat(params.row.price);
            const diff = (!isNaN(stationPrice) && !isNaN(companyPrice)) ? companyPrice - stationPrice : 0;
            const color = diff > 0 ? '#19be6b' : diff < 0 ? '#ed4014' : '#808695';
            return h('span', {
              style: {
                fontWeight: 'bold',
                color: color
              }
            }, (diff > 0 ? '+' : '') + diff.toFixed(2));
          }},
          {title: '利润(元)', key: 'profit', align: "center", width: 150, render: (h, params) => {
            // 优先使用接口返回的 profit 字段，否则前端计算（单价 - 站点价格）× 升数
            let profit = parseFloat(params.row.profit);
            if (isNaN(profit)) {
              const stationPrice = parseFloat(this.selectedStation && this.selectedStation.price);
              const companyPrice = parseFloat(params.row.price);
              const diff = (!isNaN(stationPrice) && !isNaN(companyPrice)) ? companyPrice - stationPrice : 0;
              profit = diff * parseFloat(params.row.total_litre || 0);
            }
            const color = profit > 0 ? '#19be6b' : profit < 0 ? '#ed4014' : '#808695';
            return h('span', {
              style: {
                fontWeight: 'bold',
                color: color
              }
            }, '¥' + profit.toFixed(2));
          }},
          {title: '发起申请', key: 'action', align: 'center', width: 180, render: (h, params) => {
            const row = params.row;
            const oldPrice = Number(row.price || 0);
            const inputValue = row._apply_price !== undefined ? row._apply_price : (oldPrice > 0 ? oldPrice.toFixed(2) : '');
            return h('div', {
              style: {
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: '6px'
              }
            }, [
              h('Input', {
                style: { width: '70px' },
                props: { value: inputValue, size: 'small', placeholder: '价格' },
                on: {
                  input: (val) => { this.onInlineApplyPriceInput(row, val); },
                  'on-blur': () => { this.onInlineApplyPriceBlur(row, oldPrice); }
                }
              }),
              h('Button', {
                props: { type: 'warning', size: 'small', loading: !!row._apply_submitting },
                on: {
                  click: () => {
                    this.submitInlinePriceAdjustment(row, 'station-company');
                  }
                }
              }, '申请调价')
            ]);
          }}
        ],
        stationListColumn: [
          {title: '排名', key: 'rank', width: 90, align: "center", render: (h, params) => {
            const rank = params.index + 1;
            let color = '#808695';
            let bgColor = '#f8f8f9';
            let icon = '';
            
            if (rank === 1) {
              color = '#fff';
              bgColor = '#ff9900';
              icon = '🥇';
            } else if (rank === 2) {
              color = '#fff';
              bgColor = '#a0a0a0';
              icon = '🥈';
            } else if (rank === 3) {
              color = '#fff';
              bgColor = '#cd7f32';
              icon = '🥉';
            }
            
            return h('div', {
              style: {
                display: 'inline-flex',
                alignItems: 'center',
                justifyContent: 'center',
                width: '50px',
                height: '28px',
                borderRadius: '14px',
                backgroundColor: bgColor,
                color: color,
                fontWeight: 'bold',
                fontSize: '13px',
                boxShadow: rank <= 3 ? '0 2px 4px rgba(0,0,0,0.1)' : 'none'
              }
            }, rank <= 3 ? `${icon} ${rank}` : rank);
          }},
          {title: '站点名称', key: 'gas_name', align: "left", minWidth: 200, render: (h, params) => {
            return h('div', {
              style: {
                display: 'flex',
                alignItems: 'center',
                fontWeight: params.index < 3 ? '600' : 'normal',
                color: params.index < 3 ? '#2d8cf0' : 'inherit'
              }
            }, [
              params.index < 3 ? h('Icon', {
                props: { type: 'ios-pin', size: 14 },
                style: { color: '#7367f0', marginRight: '4px' }
              }) : null,
              h('span', params.row.gas_name)
            ]);
          }},
          {title: '订单数', key: 'order_count', align: "center", width: 120},
          {title: '加油量(L)', key: 'total_litre', align: "center", width: 150, render: (h, params) => {
            return h('span', {
              style: {
                fontWeight: 'bold',
                color: '#19be6b',
                fontSize: '15px'
              }
            }, parseFloat(params.row.total_litre).toLocaleString() + ' L');
          }},
          {title: '总金额(元)', key: 'total_amount', align: "center", width: 150, render: (h, params) => {
            return h('span', {
              style: {
                fontWeight: 'bold',
                color: '#ff9900'
              }
            }, '¥' + parseFloat(params.row.total_amount).toLocaleString());
          }},
          {title: '车队单价(元/L)', key: 'price', align: "center", width: 120, render: (h, params) => {
            return h('span', {
              style: {
                fontWeight: 'bold',
                color: '#2d8cf0'
              }
            }, params.row.price.toFixed(2));
          }},
          {title: '站点单价(元/L)', key: 'gas_price', align: "center", width: 120, render: (h, params) => {
              return h('span', {
                style: {
                  fontWeight: 'bold',
                  color: '#2d8cf0'
                }
              }, params.row.gas_price.toFixed(2));
            }},
          {title: '价格差(元/L)', key: 'price_diff', align: "center", width: 120, render: (h, params) => {
            const gasPrice = parseFloat(params.row.gas_price);
            const companyPrice = parseFloat(params.row.price);
            const diff = (!isNaN(gasPrice) && !isNaN(companyPrice)) ? companyPrice - gasPrice : 0;
            const color = diff > 0 ? '#19be6b' : diff < 0 ? '#ed4014' : '#808695';
            return h('span', {
              style: {
                fontWeight: 'bold',
                color: color
              }
            }, (diff > 0 ? '+' : '') + diff.toFixed(2));
          }},
          {title: '利润(元)', key: 'profit', align: "center", width: 150, render: (h, params) => {
            // 优先使用接口返回的 profit 字段，否则前端计算（车队单价 - 站点单价）× 升数
            let profit = parseFloat(params.row.profit);
            if (isNaN(profit)) {
              const gasPrice = parseFloat(params.row.gas_price);
              const companyPrice = parseFloat(params.row.price);
              const diff = (!isNaN(gasPrice) && !isNaN(companyPrice)) ? companyPrice - gasPrice : 0;
              profit = diff * parseFloat(params.row.total_litre || 0);
            }
            const color = profit > 0 ? '#19be6b' : profit < 0 ? '#ed4014' : '#808695';
            return h('span', {
              style: {
                fontWeight: 'bold',
                color: color
              }
            }, '¥' + profit.toFixed(2));
          }},
          {title: '发起申请', key: 'action', align: 'center', width: 180, render: (h, params) => {
            const row = params.row;
            const oldPrice = Number(row.price || 0);
            const inputValue = row._apply_price !== undefined ? row._apply_price : (oldPrice > 0 ? oldPrice.toFixed(2) : '');
            return h('div', {
              style: {
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: '6px'
              }
            }, [
              h('Input', {
                style: { width: '70px' },
                props: { value: inputValue, size: 'small', placeholder: '价格' },
                on: {
                  input: (val) => { this.onInlineApplyPriceInput(row, val); },
                  'on-blur': () => { this.onInlineApplyPriceBlur(row, oldPrice); }
                }
              }),
              h('Button', {
                props: { type: 'warning', size: 'small', loading: !!row._apply_submitting },
                on: {
                  click: () => {
                    this.submitInlinePriceAdjustment(row, 'company-station');
                  }
                }
              }, '申请调价')
            ]);
          }}
        ],
        // 趋势图
        trendDays: 7,
        trendCompanyId: '',
        companyOptions: [],
        trendSummary: null,
        trendChart: null,
        trendLoading: false,
        // 车队加注排名
        companyRank: [],
        rankChart: null,
        rankLoading: false,
        rankDate: [],           // 排名时间范围（['开始日期','结束日期']）
        // 车队详情
        detailVisible: false,
        detailInfo: {},
        stationList: [],
        stationTotal: 0,
        stationPage: 1,
        stationPageSize: 10,
        stationLoading: false,
        stationSearch: { station_id: '', gas_name: '' },
        stationColumns: [
          { title: '站点名称', key: 'gas_name', align: 'left', minWidth: 150 },
          { title: '地址', key: 'gas_address', align: 'left', minWidth: 200 },
          {
            title: '车队价格', key: 'price', align: 'center', width: 100,
            render: (h, params) => h('span', { style: { fontWeight: 'bold', color: '#ff9900' } }, params.row.price || 0)
          }
        ],
        // 车队司机
        driverList: [],
        driverTotal: 0,
        driverBalanceTotal: 0,
        driverPage: 1,
        driverPageSize: 10,
        driverLoading: false,
        driverSearch: { mobile: '', car_number: '' },
        driverColumns: [
          { title: '司机卡ID', key: 'card_id', align: 'center', width: 80 },
          { title: '手机号', key: 'user_mobile', align: 'center', width: 130 },
          { title: '姓名', key: 'user_name', align: 'center', width: 90 },
          { title: '车牌号', key: 'car_number', align: 'center', width: 110 },
          {
            title: '余额', key: 'balance', align: 'center', width: 100,
            render: (h, params) => h('span', this.formatMoney(params.row.balance))
          },
          { title: '注册时间', key: 'create_time', align: 'center', width: 150 }
        ]
      };
    },
    computed: {
      avgDailyOrder() {
        if (!this.trendSummary || !this.trendDays) return 0;
        return (Number(this.trendSummary.order_num) / this.trendDays).toFixed(1);
      },
      avgDailyLitre() {
        if (!this.trendSummary || !this.trendDays) return 0;
        return (Number(this.trendSummary.litre_num) / this.trendDays).toFixed(1);
      },
      // 车队加油列表利润总和（优先接口 profit，否则（单价 - 站点价格）× 升数 前端计算）
      companyProfitTotal() {
        return this.companyListData.reduce((sum, item) => {
          const profit = parseFloat(item.profit);
          if (!isNaN(profit)) {
            return sum + profit;
          }
          const stationPrice = parseFloat(this.selectedStation && this.selectedStation.price);
          const companyPrice = parseFloat(item.price);
          const diff = (!isNaN(stationPrice) && !isNaN(companyPrice)) ? companyPrice - stationPrice : 0;
          return sum + diff * parseFloat(item.total_litre || 0);
        }, 0);
      },
      // 站点加油列表利润总和（优先接口 profit，否则（车队单价 - 站点单价）× 升数 前端计算）
      stationProfitTotal() {
        return this.stationListData.reduce((sum, item) => {
          const profit = parseFloat(item.profit);
          if (!isNaN(profit)) {
            return sum + profit;
          }
          const gasPrice = parseFloat(item.gas_price);
          const companyPrice = parseFloat(item.price);
          const diff = (!isNaN(gasPrice) && !isNaN(companyPrice)) ? companyPrice - gasPrice : 0;
          return sum + diff * parseFloat(item.total_litre || 0);
        }, 0);
      }
    },
    methods: {
      // 数据总览
      async getInfo() {
        const res = await this.$commonFun.postProxy('admin/agent_data/index');
        if (res && res.code === 200 && res.data) {
          this.info = res.data;
        }
      },

      // 获取名下车队下拉选项（用于趋势图筛选）
      async getCompanyOptions() {
        let list = [];
        let page = 1;
        let total = 0;
        do {
          const res = await this.$commonFun.postProxy('admin/agent_data/getCompanySelect', { page: page, pagesize: 100 });
          if (!res || res.code !== 200 || !res.data) {
            break;
          }
          list = list.concat(res.data);
          total = res.count || list.length;
          page++;
        } while (list.length < total && page <= 50);
        this.companyOptions = list;
      },

      // 订单趋势
      async getTrend() {
        this.trendLoading = true;
        const params = { days: this.trendDays };
        // 选择具体车队时，只统计该车队的趋势
        if (this.trendCompanyId) {
          params.company_id = this.trendCompanyId;
        }
        const res = await this.$commonFun.postProxy('admin/agent_data/getOrderTrend', params);
        this.trendLoading = false;
        if (res && res.code === 200 && res.data) {
          this.trendSummary = res.data.summary || null;
          this.$nextTick(() => {
            this.initTrendChart(res.data);
          });
        }
      },

      initTrendChart(data) {
        if (!this.$refs.trendChart) {
          return;
        }
        if (this.trendChart) {
          this.trendChart.dispose();
        }
        this.trendChart = echarts.init(this.$refs.trendChart);
        const list = data.list || [];
        const option = {
          tooltip: {
            trigger: 'axis',
            axisPointer: { type: 'cross' }
          },
          legend: {
            data: ['订单数', '加注量(L)', '金额(元)'],
            top: 10
          },
          grid: {
            left: '3%',
            right: '8%',
            bottom: '3%',
            containLabel: true
          },
          xAxis: {
            type: 'category',
            boundaryGap: true,
            data: list.map(item => item.stat_date)
          },
          yAxis: [
            {
              type: 'value',
              name: '订单数',
              position: 'left',
              axisLine: { lineStyle: { color: '#2d8cf0' } }
            },
            {
              type: 'value',
              name: '加注量(L)',
              position: 'right',
              axisLine: { lineStyle: { color: '#19be6b' } }
            },
            {
              type: 'value',
              name: '金额(元)',
              position: 'right',
              offset: 60,
              axisLine: { lineStyle: { color: '#ff9900' } }
            }
          ],
          series: [
            {
              name: '订单数',
              type: 'bar',
              barMaxWidth: 24,
              data: list.map(item => item.order_num),
              itemStyle: { color: '#2d8cf0' }
            },
            {
              name: '加注量(L)',
              type: 'line',
              smooth: true,
              yAxisIndex: 1,
              data: list.map(item => item.litre_num),
              itemStyle: { color: '#19be6b' },
              areaStyle: {
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  { offset: 0, color: 'rgba(25, 190, 107, 0.3)' },
                  { offset: 1, color: 'rgba(25, 190, 107, 0.05)' }
                ])
              }
            },
            {
              name: '金额(元)',
              type: 'line',
              smooth: true,
              yAxisIndex: 2,
              data: list.map(item => item.total_price),
              itemStyle: { color: '#ff9900' },
              areaStyle: {
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  { offset: 0, color: 'rgba(255, 153, 0, 0.25)' },
                  { offset: 1, color: 'rgba(255, 153, 0, 0.05)' }
                ])
              }
            }
          ]
        };
        this.trendChart.setOption(option);
      },

      // 排名时间范围变化时重新加载
      rankDateChange(date) {
        this.rankDate = date || [];
        this.getCompanyRank();
      },

      // 车队加注排名（TOP10，后端按时间范围统计加注量排序返回）
      async getCompanyRank() {
        this.rankLoading = true;
        const params = {};
        if (this.rankDate && this.rankDate.length === 2 && this.rankDate[0] && this.rankDate[1]) {
          params.start_time = `${this.rankDate[0]} 00:00:00`;
          params.end_time = `${this.rankDate[1]} 23:59:59`;
        }
        const res = await this.$commonFun.postProxy('admin/agent_data/getCompanyRank', params);
        this.rankLoading = false;
        if (res && res.code === 200 && res.data) {
          // 字段归一化：兼容后端返回 today_litre/today_amount/today_order_num 或通用字段
          this.companyRank = res.data.map((item, index) => {
            const litreNum = item.litre_num !== undefined ? item.litre_num
              : (item.today_litre !== undefined ? item.today_litre
                : (item.month_litre !== undefined ? item.month_litre : item.total_litre));
            const amount = item.amount !== undefined ? item.amount
              : (item.today_amount !== undefined ? item.today_amount
                : (item.month_amount !== undefined ? item.month_amount : item.total_amount));
            const orderNum = item.order_num !== undefined ? item.order_num
              : (item.today_order_num !== undefined ? item.today_order_num
                : (item.month_order_num !== undefined ? item.month_order_num : item.total_order_num));
            return { ...item, rank: index + 1, litre_num: litreNum, amount, order_num: orderNum };
          });
        }
        this.$nextTick(() => {
          this.initRankChart();
        });
      },

      initRankChart() {
        if (!this.$refs.rankChart) {
          return;
        }
        if (this.rankChart) {
          this.rankChart.dispose();
        }
        this.rankChart = echarts.init(this.$refs.rankChart);
        const list = this.companyRank || [];
        const option = {
          tooltip: {
            trigger: 'axis',
            axisPointer: { type: 'shadow' },
            formatter: (params) => {
              const item = list[params[0].dataIndex];
              if (!item) return '';
              return [
                `<b>${item.rank}. ${item.company_name}</b>`,
                `加注量：${this.formatLitre(item.litre_num)} L`,
                `金额：¥ ${this.formatMoney(item.amount)}`,
                `订单：${item.order_num || 0}`
              ].join('<br/>');
            }
          },
          grid: { left: '3%', right: '8%', bottom: '3%', top: '10', containLabel: true },
          xAxis: { type: 'value', name: '加注量(L)' },
          yAxis: {
            type: 'category',
            inverse: true,
            data: list.map(item => `${item.rank}. ${item.company_name}`),
            axisLabel: { fontSize: 12 }
          },
          series: [
            {
              name: '加注量(L)',
              type: 'bar',
              data: list.map(item => item.litre_num),
              barMaxWidth: 18,
              itemStyle: {
                color: new echarts.graphic.LinearGradient(0, 0, 1, 0, [
                  { offset: 0, color: '#2d8cf0' },
                  { offset: 1, color: '#19be6b' }
                ])
              },
              label: {
                show: true,
                position: 'right',
                formatter: (params) => this.formatLitre(params.value)
              }
            }
          ]
        };
        this.rankChart.setOption(option);
        // 点击条形图打开车队详情
        this.rankChart.off('click');
        this.rankChart.on('click', (params) => {
          const item = list[params.dataIndex];
          if (item && item.company_id) {
            this.openCompanyDetail(item);
          }
        });
      },

      // 车队列表列定义（render 中需要调用组件方法，故在 created 中构建）
      buildFleetColumn() {
        return [
          {
            title: '车队名称', key: 'company_name', align: 'left', minWidth: 160,
            render: (h, params) => h('a', {
              style: { color: '#2d8cf0' },
              on: { click: (event) => {
                // 阻止冒泡，避免同时触发行点击事件导致重复请求
                event.stopPropagation();
                this.openCompanyDetail(params.row);
              } }
            }, params.row.company_name)
          },
          { title: '负责人', key: 'manager_name', align: 'center', width: 90 },
          { title: '手机号', key: 'manager_mobile', align: 'center', width: 130 },
          { title: '站点数', key: 'station_num', align: 'center', width: 80 },
          { title: '今日订单', key: 'today_order_num', align: 'center', width: 90 },
          {
            title: '今日升数(L)', key: 'today_litre_num', align: 'center', width: 100,
            render: (h, params) => h('span', { style: { color: '#19be6b' } }, this.formatLitre(params.row.today_litre_num))
          },
          {
            title: '今日金额', key: 'today_amount', align: 'center', width: 110,
            render: (h, params) => h('span', { style: { color: '#ff9900' } }, this.formatMoney(params.row.today_amount))
          },
          { title: '本月订单', key: 'month_order_num', align: 'center', width: 90 },
          {
            title: '本月金额', key: 'month_amount', align: 'center', width: 110,
            render: (h, params) => h('span', { style: { color: '#ff9900' } }, this.formatMoney(params.row.month_amount))
          },
          { title: '累计订单', key: 'total_order_num', align: 'center', width: 90 },
          {
            title: '累计金额', key: 'total_amount', align: 'center', width: 110,
            render: (h, params) => h('span', { style: { color: '#ff9900' } }, this.formatMoney(params.row.total_amount))
          },
          // {
          //   title: '余额', key: 'balance', align: 'center', width: 100,
          //   render: (h, params) => h('span', this.formatMoney(params.row.balance))
          // },
          {
            title: '单价/计费', key: 'unit_price', align: 'center', width: 110,
            render: (h, params) => h('span', `${params.row.unit_price || 0} / ${params.row.pay_type_name || '-'}`)
          },
          // {
          //   title: '带票', key: 'bill_type_name', align: 'center', width: 80,
          //   render: (h, params) => h('Tag', { props: { color: params.row.is_bill === 1 ? 'blue' : 'default' } }, params.row.bill_type_name || '-')
          // },
          {
            title: '操作', key: 'action', align: 'center', width: 90, fixed: 'right',
            render: (h, params) => h('Button', {
              props: { type: 'primary', size: 'small' },
              on: { click: (event) => {
                // 阻止冒泡，避免同时触发行点击事件导致重复请求
                event.stopPropagation();
                this.openCompanyDetail(params.row);
              } }
            }, '详情')
          }
        ];
      },

      searchFleet() {
        if (this.$refs.fleetTable) {
          this.$refs.fleetTable.searchAndResetPage();
        }
      },

      // 点击"名下车队"卡片，滚动到页面底部车队列表
      scrollToFleetList() {
        const el = document.getElementById('fleetListSection');
        if (el) {
          el.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      },

      // 点击订单卡片，跳转到订单列表并带筛选条件
      // type: today=今日 month=本月 ''=全部；refundStatus: 1=退款中(待退款) 5=已退款
      goToOrderList(type, refundStatus) {
        const query = {};
        if (type === 'today') {
          const today = this.formatDate(new Date());
          query.create_time = `${today} 00:00:00,${today} 23:59:59`;
        } else if (type === 'month') {
          const now = new Date();
          const firstDay = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}-01`;
          const today = this.formatDate(now);
          query.create_time = `${firstDay} 00:00:00,${today} 23:59:59`;
        }
        if (refundStatus) {
          query.refund_status = refundStatus;
        }
        this.$router.push({ name: '车队订单', query });
      },

      formatDate(date) {
        if (!date) return '';
        const d = new Date(date);
        return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
      },

      // 打开车队详情
      openCompanyDetail(row) {
        if (!row || !row.company_id) {
          return;
        }
        // 同一个车队详情请求加载中，避免重复发起请求
        if (this.stationLoading && this.detailInfo.company_id === row.company_id) {
          return;
        }
        this.detailInfo = { ...row };
        this.detailVisible = true;
        this.stationPage = 1;
        this.driverPage = 1;
        this.loadCompanyDetail(row.company_id, 1);
        this.loadCompanyDrivers(row.company_id, 1);
      },

      // 车队详情 + 站点列表
      async loadCompanyDetail(companyId, page = 1) {
        this.stationLoading = true;
        const params = {
          company_id: companyId,
          page: page,
          pagesize: this.stationPageSize
        };
        // 站点搜索条件：ID 精确匹配，名称模糊匹配
        if (this.stationSearch.station_id) {
          params.station_id = this.stationSearch.station_id;
        }
        if (this.stationSearch.gas_name) {
          params.gas_name = this.stationSearch.gas_name;
        }
        const res = await this.$commonFun.postProxy('admin/agent_data/getCompanyDetail', params);
        this.stationLoading = false;
        if (res && res.code === 200 && res.data) {
          this.detailInfo = { ...this.detailInfo, ...res.data };
          this.stationList = res.data.station_list || [];
          this.stationTotal = res.data.station_num || 0;
          this.stationPage = page;
        }
      },

      loadStationPage(page) {
        if (this.detailInfo.company_id) {
          this.loadCompanyDetail(this.detailInfo.company_id, page);
        }
      },

      // 站点搜索（重置到第一页重新查询）
      searchStation() {
        if (!this.detailInfo.company_id) {
          return;
        }
        this.stationPage = 1;
        this.loadCompanyDetail(this.detailInfo.company_id, 1);
      },

      // 重置站点搜索条件
      resetStationSearch() {
        this.stationSearch = { station_id: '', gas_name: '' };
        this.searchStation();
      },

      // 车队司机列表
      async loadCompanyDrivers(companyId, page = 1) {
        this.driverLoading = true;
        const params = {
          company_id: companyId,
          page: page,
          pagesize: this.driverPageSize
        };
        // 司机搜索条件：手机号精确匹配，车牌号模糊匹配
        if (this.driverSearch.mobile) {
          params.mobile = this.driverSearch.mobile;
        }
        if (this.driverSearch.car_number) {
          params.car_number = this.driverSearch.car_number;
        }
        const res = await this.$commonFun.postProxy('admin/agent_data/getCompanyDriverList', params);
        this.driverLoading = false;
        if (res && res.code === 200 && res.data) {
          this.driverList = res.data;
          this.driverTotal = res.count || 0;
          this.driverPage = page;
          // 卡余额总额：优先取接口返回的 balance_total（全部司机合计），否则按当前页求和兜底
          const balanceTotal = res.extra['balance_total'] ||res.extra['balance_total'] !== undefined ? res.extra['balance_total'] : res.extra['balance_total'];
          this.driverBalanceTotal = balanceTotal !== undefined ? balanceTotal : this.driverList.reduce((sum, item) => sum + Number(item.balance || 0), 0);
        }
      },

      loadDriverPage(page) {
        if (this.detailInfo.company_id) {
          this.loadCompanyDrivers(this.detailInfo.company_id, page);
        }
      },

      // 司机搜索（重置到第一页重新查询）
      searchDriver() {
        if (!this.detailInfo.company_id) {
          return;
        }
        this.driverPage = 1;
        this.loadCompanyDrivers(this.detailInfo.company_id, 1);
      },

      // 重置司机搜索条件
      resetDriverSearch() {
        this.driverSearch = { mobile: '', car_number: '' };
        this.searchDriver();
      },

      formatMoney(value) {
        return Number(value || 0).toFixed(2);
      },

      formatLitre(value) {
        return Number(value || 0).toFixed(1);
      },
      handleOilRangeDone(res) {
        this.oilRangeSummary = (res && res.extra) || {};
        return res;
      },
      handleCompanyOilRangeDone(res) {
        this.companyOilRangeSummary = (res && res.extra) || {};
        return res;
      },
      handleRangeDateChange(formName, value) {
        const target = this[formName];
        if (!target) {
          return;
        }
        if (!value || !Array.isArray(value)) {
          target.searchDay = '';
          target.start_time = '';
          target.end_time = '';
          target.dateRange = [];
          return;
        }
        target.searchDay = '';
        target.start_time = value[0] || '';
        target.end_time = value[1] || '';
        target.dateRange = value.slice();
      },
      buildRangeSearchParams(form) {
        const hasSingleDay = form.searchDay && !form.start_time && !form.end_time;
        const searchDay = hasSingleDay ? form.searchDay : '';
        return {
          searchDay,
          start_time: form.start_time || '',
          end_time: form.end_time || ''
        };
      },
      sanitizeNumericText(val, allowNegative = false) {
        let text = val === undefined || val === null ? '' : String(val);
        text = text.replace(allowNegative ? /[^\d.\-]/g : /[^\d.]/g, '');
        if (allowNegative) {
          text = text.replace(/(?!^)-/g, '');
        }
        const parts = text.split('.');
        if (parts.length > 2) {
          text = `${parts.shift()}.${parts.join('')}`;
        }
        if (text.startsWith('.')) text = `0${text}`;
        if (text.startsWith('-.')) text = text.replace('-.', '-0.');
        return text;
      },
      onInlineApplyPriceInput(row, val) {
        const text = this.sanitizeNumericText(val, false);
        this.$set(row, '_apply_price', text);
      },
      onInlineApplyPriceBlur(row, defaultPrice = 0) {
        const raw = row._apply_price;
        if (raw === '' || raw === null || raw === undefined) return;
        const num = Number(raw);
        if (Number.isNaN(num)) {
          this.$Message.warning('请输入数字金额');
          this.$set(row, '_apply_price', defaultPrice > 0 ? defaultPrice.toFixed(2) : '');
          return;
        }
        if (num <= 0) {
          this.$Message.warning('金额需大于0');
          this.$set(row, '_apply_price', defaultPrice > 0 ? defaultPrice.toFixed(2) : '');
          return;
        }
        this.$set(row, '_apply_price', num.toFixed(2));
      },

      // 加油站排行排序
      oilRangeSortChange(data) {
        this.oilRangeForm.sortKey = data.key;
        this.oilRangeForm.sortType = data.order === 'asc' ? 'asc' : 'desc';
        this.$refs.oilRangeTable.searchAndResetPage();
      },
      // 车队加油排行排序
      companyOilRangeSortChange(data) {
        this.companyOilRangeForm.sortKey = data.key;
        this.companyOilRangeForm.sortType = data.order === 'asc' ? 'asc' : 'desc';
        this.$refs.companyOilRangeTable.searchAndResetPage();
      },
      // 计算弹窗自适应尺寸：宽度占屏幕70%，表格最大高度适配屏幕
      calcModalSize() {
        const h = window.innerHeight || 800;
        // 表格最大高度 = 屏幕高度80% - 弹窗头部/信息条/表头/内边距等固定占用
        this.tableMaxHeight = Math.max(300, Math.floor(h * 0.8 - 260));
      },
      // 显示站点对应的车队列表
      async showStationCompanyList(station) {
        this.selectedStation = station;
        this.showCompanyModal = true;
        // 调用接口获取车队列表数据
        await this.getStationCompanyList(station);
      },
      // 获取站点下车队列表数据（独立方法）
      async getStationCompanyList(station) {
        this.companyListLoading = true;
        try {
          const rangeParams = this.buildRangeSearchParams(this.oilRangeForm);
          const res = await this.$commonFun.postProxy('admin/agent_data/stationCompanyList', {
            station_id: station.station_id,
            searchDay: (rangeParams.start_time || rangeParams.end_time) ? '' : (rangeParams.searchDay || this.formatDate(new Date())),
            start_time: rangeParams.start_time,
            end_time: rangeParams.end_time
          });
          if (res.code === 200 && res.data && res.data.companies) {
            let companies = res.data.companies || [];
            // 按照加油量（total_litre）降序排序
            companies.sort((a, b) => {
              return parseFloat(b.total_litre) - parseFloat(a.total_litre);
            });
            this.companyListData = companies;
            // 更新 selectedStation 的价格信息（从接口返回的 data 中获取）
            if (res.data.price !== undefined) {
              this.$set(this.selectedStation, 'price', res.data.price);
            }
          } else {
            this.companyListData = [];
            this.$Message.warning(res.msg || '暂无数据');
          }
        } catch (error) {
          console.error('获取车队列表失败:', error);
          this.$Message.error('获取数据失败');
          this.companyListData = [];
        } finally {
          this.companyListLoading = false;
        }
      },
      // 显示车队对应的站点列表
      async showCompanyStationList(company) {
        this.selectedCompany = company;
        this.showStationModal = true;
        // 调用接口获取站点列表数据
        await this.getCompanyStationList(company);
      },
      // 获取车队下站点列表数据（独立方法）
      async getCompanyStationList(company) {
        this.stationListLoading = true;
        try {
          const rangeParams = this.buildRangeSearchParams(this.companyOilRangeForm);
          const res = await this.$commonFun.postProxy('admin/agent_data/companyStationList', {
            company_id: company.company_id,
            searchDay: (rangeParams.start_time || rangeParams.end_time) ? '' : (rangeParams.searchDay || this.formatDate(new Date())),
            start_time: rangeParams.start_time,
            end_time: rangeParams.end_time
          });
          if (res.code === 200 && res.data && res.data.stations) {
            let stations = res.data.stations || [];
            // 按照加油量（total_litre）降序排序
            stations.sort((a, b) => {
              return parseFloat(b.total_litre) - parseFloat(a.total_litre);
            });
            this.stationListData = stations;
          } else {
            this.stationListData = [];
            this.$Message.warning(res.msg || '暂无数据');
          }
        } catch (error) {
          console.error('获取站点列表失败:', error);
          this.$Message.error('获取数据失败');
          this.stationListData = [];
        } finally {
          this.stationListLoading = false;
        }
      },
      async submitInlinePriceAdjustment(row, sourceType) {
        const isStationCompany = sourceType === 'station-company';
        const companyId = isStationCompany ? Number(row.company_id || 0) : Number(this.selectedCompany && this.selectedCompany.company_id || 0);
        const stationId = isStationCompany ? Number(this.selectedStation && this.selectedStation.station_id || 0) : Number(row.station_id || 0);
        const oldPrice = Number(row.price || 0);
        const newPrice = Number(row._apply_price !== undefined ? row._apply_price : oldPrice);

        if (!companyId || !stationId) {
          this.$Message.error('缺少申请调价所需参数');
          return;
        }

        if (!newPrice || newPrice <= 0) {
          this.$Message.error('请输入正确的新车队价格');
          return;
        }
        if (Number(newPrice.toFixed(2)) === Number(oldPrice.toFixed(2))) {
          this.$Message.error('新价格与当前价格一致');
          return;
        }
        this.$set(row, '_apply_submitting', true);
        let res = await this.$commonFun.postProxy('admin/company/applyCompanyStationPriceAdjust', {
          company_id: companyId,
          station_id: stationId,
          apply_price: Number(newPrice.toFixed(2))
        });
        this.$set(row, '_apply_submitting', false);
        this.$commonFun.dealApiResult(res, () => {
          this.$commonFun.successTip(res.msg || '申请成功', async () => {
            if (sourceType === 'station-company' && this.selectedStation) {
              await this.getStationCompanyList(this.selectedStation);
            } else if (sourceType === 'company-station' && this.selectedCompany) {
              await this.getCompanyStationList(this.selectedCompany);
            }
          });
        });
      }
    },
    created() {
      this.fleetColumn = this.buildFleetColumn();
      this.getInfo();
      this.getCompanyOptions();
      this.getTrend();
      // 排名默认展示今日数据
      const today = this.formatDate(new Date());
      this.rankDate = [today, today];
      this.getCompanyRank();
    },
    mounted() {
      // 计算弹窗自适应尺寸
      this.calcModalSize();
      window.addEventListener('resize', this.calcModalSize);
      // 监听窗口大小变化
      window.addEventListener('resize', () => {
        if (this.trendChart) {
          this.trendChart.resize();
        }
        if (this.rankChart) {
          this.rankChart.resize();
        }
      });
    },
    beforeDestroy() {
      // 移除窗口尺寸监听
      window.removeEventListener('resize', this.calcModalSize);
      if (this.trendChart) {
        this.trendChart.dispose();
        this.trendChart = null;
      }
      if (this.rankChart) {
        this.rankChart.dispose();
        this.rankChart = null;
      }
    }
  };
</script>

<style scoped lang="less">
.table-summary-bar {
  display: flex;
  justify-content: flex-end;
  gap: 16px;
  padding: 8px 12px 10px;
  font-size: 12px;
  color: #515a6e;
  background: linear-gradient(90deg, rgba(45, 140, 240, 0.04), rgba(25, 190, 107, 0.04));
  border-radius: 6px;
  margin: 0 0 8px;

  span {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    font-weight: 600;
  }
}

// 统计卡片 - 现代化简洁风格
.stat-card {
  margin-bottom: 16px;
  transition: all 0.3s ease;
  border-radius: 8px;
  overflow: hidden;
  position: relative;
  cursor: pointer;

  &:hover {
    transform: translateY(-4px);
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);
  }

  /deep/ .ivu-card-body {
    padding: 24px;
  }

  .stat-content {
    display: flex;
    flex-direction: column;
    gap: 8px;

    .stat-value {
      font-size: 32px;
      font-weight: 700;
      color: #17233d;
      line-height: 1.2;
    }

    .stat-label {
      font-size: 14px;
      color: #808695;
      font-weight: 500;
    }

    .stat-sub {
      font-size: 12px;
      color: #808695;
      margin-top: 2px;

      .split {
        margin: 0 6px;
        color: #dcdee2;
      }
    }

    // 双数据展示（待退款/已退款）
    .stat-double {
      display: flex;
      align-items: center;
      width: 100%;

      .stat-double-item {
        flex: 1;
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 4px;
        padding: 10px 0;
        border-radius: 6px;
        cursor: pointer;
        transition: all 0.2s ease;

        &:hover {
          background: #f5f7fa;
        }

        .stat-value {
          font-size: 28px;
        }

        .stat-label {
          display: flex;
          align-items: center;
          gap: 4px;
          font-size: 13px;
        }
      }

      // 待退款 - 红色数字
      .stat-refund-wait .stat-value {
        color: #ed4014;
      }

      // 已退款 - 绿色数字
      .stat-refund-done .stat-value {
        color: #19be6b;
      }

      .stat-divider {
        width: 1px;
        height: 40px;
        background: #e8eaec;
      }
    }

    .stat-icon {
      position: absolute;
      right: 20px;
      top: 50%;
      transform: translateY(-50%);
      font-size: 48px;
      opacity: 0.15;
    }
  }

  &.stat-blue {
    border-left: 4px solid #2d8cf0;
    .stat-icon { color: #2d8cf0; }
  }

  &.stat-green {
    border-left: 4px solid #19be6b;
    .stat-icon { color: #19be6b; }
  }

  &.stat-orange {
    border-left: 4px solid #ff9900;
    .stat-icon { color: #ff9900; }
  }

  &.stat-red {
    border-left: 4px solid #ed4014;
    .stat-icon { color: #ed4014; }
  }

  &.stat-purple {
    border-left: 4px solid #7367f0;
    .stat-icon { color: #7367f0; }
  }

  &.stat-cyan {
    border-left: 4px solid #00c5dc;
    .stat-icon { color: #00c5dc; }
  }

  &.stat-success {
    border-left: 4px solid #19be6b;
    .stat-icon { color: #19be6b; }
  }

  &.stat-warning {
    border-left: 4px solid #faad14;
    .stat-icon { color: #faad14; }
  }
}

// 排名列表卡片
.ranking-list-card {
  margin-bottom: 16px;
  border-radius: 8px;

  /deep/ .ivu-card-head {
    padding: 16px 20px;
    border-bottom: 2px solid #f0f0f0;
    background: linear-gradient(to right, #fafafa, #fff);
  }

  .card-title-with-badge {
    display: flex;
    align-items: center;
    justify-content: space-between;

    .title-text {
      font-size: 16px;
      font-weight: 600;
      color: #17233d;
    }
  }
}

// 图表卡片
.chart-card {
  margin-bottom: 16px;
  border-radius: 8px;

  /deep/ .ivu-card-head {
    padding: 16px 20px;
    border-bottom: 2px solid #f0f0f0;
    background: linear-gradient(to right, #fafafa, #fff);
  }

  /deep/ .ivu-card-body {
    padding: 20px;
  }

  .card-title-with-badge {
    display: flex;
    align-items: center;
    justify-content: space-between;

    .title-text {
      font-size: 16px;
      font-weight: 600;
      color: #17233d;
    }

    .trend-filters {
      display: flex;
      gap: 10px;
    }

    .rank-title {
      display: flex;
      flex-direction: column;
      line-height: 1.4;

      .rank-tip {
        font-size: 12px;
        color: #808695;
        font-weight: 400;
      }
    }

    .rank-sub {
      font-size: 12px;
      color: #808695;
      font-weight: 400;
    }
  }
}

// 趋势汇总卡片
.trend-summary {
  display: flex;
  gap: 16px;
  margin-bottom: 20px;
  padding: 16px;
  background: #f8f8f9;
  border-radius: 4px;

  .trend-summary-item {
    flex: 1;
    text-align: center;
    padding: 12px;
    background: white;
    border-radius: 4px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);

    .ts-label {
      font-size: 12px;
      color: #8c8c8c;
      margin-bottom: 8px;
    }

    .ts-value {
      font-size: 24px;
      font-weight: bold;
    }

    .ts-blue { color: #2d8cf0; }
    .ts-green { color: #19be6b; }
    .ts-orange { color: #ff9900; }
    .ts-purple { color: #7367f0; }

    .ts-split {
      margin: 0 4px;
      font-size: 14px;
      color: #8c8c8c;
    }
  }
}

// 车队详情抽屉
.detail-info {
  margin-bottom: 16px;
  padding: 12px 16px;
  background: #f8f8f9;
  border-radius: 4px;

  .detail-info-item {
    padding: 5px 0;
    font-size: 13px;

    .label {
      color: #808695;
    }

    .value {
      color: #17233d;
      font-weight: 500;
    }
  }
}

.detail-stats {
  display: flex;
  gap: 16px;
  margin-bottom: 8px;

  .detail-stat-card {
    flex: 1;
    background: #f8f8f9;
    border-radius: 4px;
    padding: 12px 16px;

    .ds-title {
      font-size: 13px;
      color: #808695;
      font-weight: 600;
      margin-bottom: 8px;
      border-left: 3px solid #2d8cf0;
      padding-left: 8px;
    }

    .ds-row {
      display: flex;
      justify-content: space-between;
      font-size: 13px;
      line-height: 26px;

      .ds-label {
        color: #808695;
      }

      .ds-value {
        font-weight: 600;
        color: #17233d;
      }
    }
  }
}

.station-search {
  display: flex;
  gap: 10px;
  margin-bottom: 12px;

  .driver-balance-total {
    display: flex;
    align-items: center;
    gap: 4px;
    margin-left: 12px;
    font-size: 13px;
    color: #808695;

    b {
      color: #ed4014;
      font-size: 16px;
    }
  }
}

.station-page {
  margin-top: 12px;
  text-align: right;
}

.price-apply-summary {
  margin-bottom: 16px;
  padding: 12px 14px;
  background: #f8f8f9;
  border-radius: 6px;
  border-left: 3px solid #ff9900;

  .summary-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    line-height: 28px;
    font-size: 13px;
  }

  .label {
    color: #808695;
  }

  .value {
    color: #17233d;
    font-weight: 600;
    margin-left: 12px;
  }
}
</style>
